import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Output,
  EventEmitter,
  ElementRef,
  HostListener,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';
import { Router } from '@angular/router';
import { DocumentService } from '@app/shared/services';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { Subscription } from 'rxjs';
import { environment } from '@env/environment';
import { select, Store } from '@ngrx/store';
import * as loginSelectors from '../../../../../root-store/login-store/login.selector';
import { SecurityComponent } from '../../securitykey/container/security/security.component';
import { SecurityStepperComponent } from '../../securitykey/components/security-stepper/security-stepper.component';
import { ManageSecurityKeyComponent } from './manage-security-key/manage-security-key.component';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'add-security-key',
  templateUrl: './add-security-key.component.html',
  styleUrls: ['./add-security-key.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddSecurityKeyComponent implements OnInit, OnDestroy {
  @Input() currentFormId;
  @Input() mode;
  @Input() isRemoveEditSaveSharing;
  @Input() currentuserId;
  @Input() data;
  @Input() origin;

  @Input() formName;
  @Input() isSecurityKeyAdded;
  @Input() sk = null;

  @Output() securityKeyAdded: EventEmitter<any> = new EventEmitter<any>();

  vaultStateObject;
  stateObject;
  vaultStateObject$: any;
  showAvailableSecurityKeys = false;
  panelOpenState: boolean = true;
  isDataLoading = true;
  currentUser: any;
  screenWidth: number;
  environment = environment;
  allowEditPermission = true;
  securityKeyData: Array<any> = [];
  addedSecurityKey = [];
  subscription = new Subscription();

  constructor(
    private documentService: DocumentService,
    private router: Router,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private elementRef: ElementRef,
    private vaultService: VaultStoreEffects,
    private _store: Store
  ) {
    this.screenWidth = window.innerWidth;
    this.subscription.add(
      this._store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
        if (result) {
          this.currentUser = result;
        } else {
          this.currentUser = null;
          router.navigate(['/']);
        }
      })
    );

    this.vaultStateObject$ = this.vaultService.vaultObject;
    this.subscription.add(
      this.vaultStateObject$.subscribe((item) => {
        this.stateObject = item;
        this.cd.markForCheck();
      })
    );
  }

  @HostListener('document:click', ['$event.target'])
  public onClick(target) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.showAvailableSecurityKeys = false;
    }
  }

  onClickedOutside(e: Event) {
    this.showAvailableSecurityKeys = false;
  }

  ngOnInit() {
    if (this.router.url.includes('network') && !this.router.url.includes('admin=true') && this.origin == 'vault') {
      this.allowEditPermission = false;
    }
  }

  ngAfterViewInit() {
    this.getFormSecurityKey();
  }

  async getFormSecurityKey(update = false, selectedSecurity_key = null) {
    // let userId = this.data.vault_user_form_user_id
    //   ? this.data.vault_user_form_user_id
    //   : this.stateObject.userId
    //   ? this.stateObject.userId
    //   : this.data?.user_id;
    let userId = this.currentuserId;
    if (userId) {
      this.subscription.add(
        this.documentService.getSecurityKeyWidhId(userId).subscribe(
          (res) => {
            this.isDataLoading = false;
            if (res[0].keys.Items != undefined && res[0].keys.Items.length) {
              this.securityKeyData = [...res[0].keys.Items];
              if (this.isSecurityKeyAdded) this.addedSecurityKey = [...res[0].keys.Items];
              if (update) {
                this.securityKeyAdded.emit({
                  key_added: true,
                  selectedSecurity_key: selectedSecurity_key,
                });
                this.toastr.success('File has been protected with Security key');
              } else {
                this.addedSecurityKey = [];
                res[0].keys.Items.forEach((item) => {
                  if (this.sk == item.sk) {
                    this.addedSecurityKey.push({
                      ...item,
                      form_name: item.keyName,
                      key_path: 'assets/images/key-blue.svg',
                    });
                  }
                });
              }
              this.cd.detectChanges();
            } else {
              this.isSecurityKeyAdded = false;
              this.cd.detectChanges();
            }
          },
          (error) => {
            this.toastr.error(error);
          }
        )
      );
    }
  }

  setValue(event) {
    this.openSecurityKeyDialog();
  }

  createPremiumKey() {
    const dialogRef = this.dialog.open(ManageSecurityKeyComponent, {
      data: {
        securityKeyData: this.securityKeyData,
        addedSecurityKey: this.addedSecurityKey,
        currentuserId: this.currentuserId,
        formName: this.formName,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        if (this.addedSecurityKey.length == 0 && res.linkedTemplate.length == 0) {
          return;
        }
        if (this.addedSecurityKey.length == 1 && res.linkedTemplate.length == 1 && res.linkedTemplate[0].sk == this.addedSecurityKey[0].sk) {
          return;
        }
        if (res.linkedTemplate.length > 0) {
          this.selectSecurityKey(null, res.linkedTemplate[0]);
        } else {
          this.removeSecurityKey(null, null);
        }
      })
    );
  }
  openSecurityKeyDialog() {
    const dialogRef = this.dialog.open(SecurityComponent, {
      panelClass: 'full-window-dialog',
      data: { securityKeyFirstStep: true },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        if (res && res['openNextStep']) {
          const dialogRef2 = this.dialog.open(SecurityStepperComponent, {
            panelClass: 'full-window-dialog',
            disableClose: true,
            data: { showkeyName: true, showSecurityKey: true, showHint: true, showSafeguardKey: true },
          });
          this.subscription.add(
            dialogRef2.afterClosed().subscribe((res) => {
              if (res != undefined) {
                if (res?.confirmation) {
                  this.isSecurityKeyAdded = true;
                  this.getFormSecurityKey(true);
                } else if (res?.isSkip) {
                  this.isSecurityKeyAdded = false;
                }
              }
            })
          );
          this.cd.detectChanges();
        } else {
          this.isSecurityKeyAdded = false;
          this.cd.detectChanges();
        }
      })
    );
  }

  selectSecurityKey($event, data) {
    this.sk = data.sk;
    this.showAvailableSecurityKeys = false;
    this.getFormSecurityKey(true, data);
    this.addedSecurityKey.push(data);
    this.cd.detectChanges();
  }

  askConfirmation(event, data) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '500px',
      data: {
        title: 'Remove Premium Encryption',
        materialIcon: 'delete',
        text: `This template will no longer be protected by ${data.keyName}. You can add an encryption key back to this template at any point in the future.`,
        proceedTitle: 'Delete',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((res) => {
        if (res.confirmation) {
          this.removeSecurityKey(event, data);
        }
      })
    );
  }
  removeSecurityKey(event, data) {
    this.addedSecurityKey.pop();
    this.sk = null;
    this.addedSecurityKey = [];
    this.isSecurityKeyAdded = false;
    this.securityKeyAdded.emit({
      key_added: false,
      selectedSecurity_key: null,
    });
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
  setCustomPosition() {
    var output = document.getElementById('add-security-container').getBoundingClientRect();
    setTimeout(() => {
      // this will make the execution after the above boolean has changed
      eval(`document.getElementById('add-security-search-box').style.top ='${+output.y.toFixed() + 78}px';`);
    }, 0);
  }
}
